module.exports = __webpack_public_path__ + "ee85adf68f7d85d8ba51f7002f611a50.pdf";